<template>
<div>
    <Header></Header>
    <header class="py-3 mb-4 border-bottom">
        <div class="container d-flex flex-wrap justify-content-center">
            <a class="d-flex align-items-center mb-3 mb-lg-0 me-lg-auto text-dark text-decoration-none">
                <svg class="bi me-2" width="40" height="32">
                    <use xlink:href="#bootstrap" />
                </svg>
                <span class="fs-4"></span>
            </a>

            <form class="col-12 col-lg-auto mb-3 mb-lg-0">
                <input type="search" class="form-control" placeholder="Search..." aria-label="Search" v-model="searchString">
            </form>
        </div>
    </header>
    <div class="container">
        <div v-if="loading" class="d-flex align-items-center justify-content-center gap-3 p-3 font-500">
            <b-spinner></b-spinner> Loading...
        </div>
        <table class="table table-striped" v-else-if="leads && leads.length > 0">
            <thead>
                <tr>
                    <th>#</th>
                    <th>ID</th>
                    <th>Email</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                <tr class="clickable-row" v-for="(lead,index) in leads" :key="lead.name" @click="studentInformation(lead.name,lead.party_name)">
                    <td><strong>{{ index + 1 }}</strong></td>
                    <td><strong>{{ lead.name }}</strong></td>
                    <td>{{ lead.party_name }}</td>
                    <td>{{ lead.status }}</td>
                </tr>
            </tbody>
        </table>
        <h5 v-else-if="leads && leads.length == 0 && !loading" class="text-center text-muted p-4 pt-0 m-0">
            No students found
        </h5>
    </div>
    <Footer></Footer>
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Header from '../components/Layout/Header.vue';
import Footer from '../components/Layout/Footer.vue';
import {
    mapState
} from 'vuex';
export default {
    name: 'StudentsList',
    components: {
        Datepicker,
        Header,
        Footer
    },
    data() {
        return {
            loading: false,
            selectedStudentId: null,
            selectedNumber: 0,
            inputFields: [],
            totalAmount: 0,
            amountExceeded: false,
            amountLess: false,
            allInputBoxesFilled: false,
            exceededAmount: 0,
            loading: false,
            studentInstallments: [],
            shouldApplyShortFormForCourses: true,
            showInstallmentDataModal: false,
            transferCourseModal: false,
            selectedStudentCourses: [],
            studentEmail: null,
            leads: [],
            filterStatus: "All",
            selectedLead: null,
            selectedEmail: null,
            searchString: null
        };
    },
    mounted() {
        $(() => {
            $('[data-bs-toggle="tooltip"]').tooltip();
        });
    },
    computed: {
        ...mapState(["erp_api_url","authorization_token"])
    },
    methods: {
        studentInformation(name, email) {
            this.selectedLead = name;
            this.selectedEmail = email;
            this.$router.push({
                path: '/Student/information',
                query: {
                    leadId: name,
                }
            });
        },
        async fetchLeadList() {
            try {
                this.loading = true;
                let apiUrl = this.erp_api_url + 'api/resource/Opportunity?limit_start=0&limit_page_length=200&filters=[["Opportunity", "status", "=", "Open"]]&fields=["name","status","opportunity_type","probability","opportunity_from","party_name","items"]';
                const response = await fetch(apiUrl, {
                    method: 'GET',
                    headers: {
                        'Authorization': `${this.authorization_token}`,
                    },
                });

                const leads = await response.json();
                this.leads = leads.data;
            } catch (error) {
                console.error('Error fetching leads:', error);
            } finally {
                this.loading = false;
            }
        },
    },
    created() {
        this.fetchLeadList();
    },
};
</script>

<style scoped>
.category-options {
    width: 1.875rem;
    height: 1.875rem;
    background: #ebebeb;
    border-radius: 50%;
    display: flex !important;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-left: auto;
}

.category-options::after {
    display: none !important;
}

.options-dropdown-item {
    padding: 0.75rem 1rem;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #000000;
    column-gap: 0.75rem;
}

.options-dropdown-item:hover {
    background-color: #ebebeb;
}

.short-form {
    cursor: pointer;
    text-decoration: none;
}

.table th {
    border: 1px solid #dee2e6;
    padding: 0.5rem;
}

.table tbody tr {
    border-bottom: 1px solid #dee2e6;
}

.table td {
    border: 1px solid #dee2e6;
    padding: 0.5rem;
}

tr {
    text-align: center;
}

td {
    text-align: center;
}

.clickable-row {
    cursor: pointer;
}
</style>
